import { post, get, put } from '../http'
const { API_URL } = require('../../../config')

// API基础路径（相对路径，因为 http.js 中已经设置了 baseURL）
const BASE_URL = '/api/auth'

// 登录
export const login = (username, password) => {
  console.log('登录请求:', { username })
  const url = `${BASE_URL}/login`
  console.log('请求URL:', url)
  return post(url, { username, password })
}

// 获取当前用户信息（带时间戳避免浏览器/CDN 返回 304 且 body 为空，导致权限被误清空）
export const getProfile = () => {
  console.log('获取用户信息')
  const url = `${BASE_URL}/profile`
  console.log('请求URL:', url)
  return get(url, { _t: Date.now() })
}

// 更新当前用户个人信息
export const updateProfile = (userData) => {
  console.log('更新个人信息:', userData)
  const url = `${BASE_URL}/update-profile`
  console.log('请求URL:', url)
  return put(url, userData)
}

export default {
  login,
  getProfile,
  updateProfile
} 